import { render } from "./SmallerScreenMenuNav.vue?vue&type=template&id=00a737a2"
import script from "./SmallerScreenMenuNav.vue?vue&type=script&lang=js"
export * from "./SmallerScreenMenuNav.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__